import CloseIcon from '../assets/icons/close.svg?react';
import { cn } from '../utils/className';

export interface MachineBadgeProps {
  /** The display name of the machine */
  name: string;
  /** Whether the badge can be removed (shows close button) */
  removable?: boolean;
  /** Callback when the remove button is clicked */
  onRemove?: () => void;
  /** Additional class names */
  className?: string;
}

export function MachineBadge({
  name,
  removable = false,
  onRemove,
  className,
}: MachineBadgeProps) {
  return (
    <div
      className={cn(
        `bg-surface-focus-support border-border-primary size-caption
        text-primary flex items-center gap-1.5 rounded border px-2 py-1
        select-none`,
        className
      )}
    >
      <span>{name}</span>
      {removable && onRemove && (
        <button
          type='button'
          onClick={onRemove}
          className='text-secondary hover:text-primary -mr-0.5 flex
            cursor-pointer items-center justify-center'
          aria-label={`Remove ${name}`}
        >
          <CloseIcon className='h-2.5 w-2.5' />
        </button>
      )}
    </div>
  );
}
